import React, { memo, useContext } from 'react'
import { Card } from 'react-components'
import { ThemeContext } from 'styled-components'

import {
    BenefitsBasicCardContainer,
    BenefitsCardBasicDescription,
    BenefitsCardBasicIconContainer,
    BenefitsCardBasicTitle,
    CardContainer,
} from './benefits-section-styles'
import { BenefitTransport } from '@common/transports/deprecated-home-page-transport'

type Props = {
    benefit: BenefitTransport
    shadowed?: boolean
}

const BenefitsCardBasic: React.FC<Props> = ({ benefit, shadowed }) => {
    const theme = useContext(ThemeContext)
    return (
        <CardContainer>
            <Card
                shadowed={shadowed}
                borderRadius={theme.typography.border.radius.small}
                backgroundColor={theme.colors.white}
                boxShadow={`0 ${theme.spacing.xxxSmall} ${theme.spacing.small} 0 #00000026`}
            >
                <BenefitsBasicCardContainer>
                    <BenefitsCardBasicIconContainer src={benefit.image.url} alt={benefit.image.alt} />
                    <BenefitsCardBasicTitle>{benefit.title}</BenefitsCardBasicTitle>
                    <BenefitsCardBasicDescription inputText={benefit.description} escapeHtml />
                </BenefitsBasicCardContainer>
            </Card>
        </CardContainer>
    )
}

export default memo(BenefitsCardBasic)
